<template>
    <div id="returnMaterManageList">
        <!-- <el-row class="clearfix" style="position: absolute;right:40px;top:16px;">
            <el-button type="success" size="medium" v-if="basicsAuth.returnMaterialAdd" @click="createOrder()">新建退料</el-button>
            <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')" >导出</el-button>
            <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 10px" @click="refresh()"></i>
        </el-row> -->
        <el-col class="searthPart">
            <el-form ref="searchForm" :inline="true" :model="searchForm" :label-position="labelPosition">
                <el-form-item class="hewidth">
                    <el-input clearable v-model.trim="searchForm.code" placeholder="编号" maxlength="50" ></el-input>
                </el-form-item>
                <el-form-item class="hewidth">
                    <el-select filterable v-model.trim="searchForm.createUser" @change="changeCreateUser" :filter-method="PinyinMatch1" placeholder="创建人" clearable>
                        <el-option v-for="(item,index) in reciverList" 
                            :label="item.staffName" 
                            :value="item.userId" 
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="hewidth">
                        <el-select filterable v-model="searchForm.returnType" placeholder="退料类型" clearable>
                            <el-option v-for="(item,index) in returnList" 
                                :label="item.paraName" 
                                :value="item.paraValue" 
                                :key="index">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  class="hewidth">
                        <el-select filterable v-model="searchForm.status" placeholder="状态" clearable>
                            <el-option v-for="(item,index) in statusList" 
                                :label="item.paraName" 
                                :value="item.paraValue" 
                                :key="index">
                            </el-option>
                        </el-select>
                    </el-form-item>
                <!-- <div class="clearfix">  -->                   
                    <el-form-item style="width:22%">
                        <el-date-picker
                            style="width: 100%;"
                            v-model="valueTime3"
                            type="daterange"
                            range-separator="-"
                            :default-time="['00:00:00', '23:59:59']"
                            start-placeholder="退料开始"
                            end-placeholder="退料开始">
                        </el-date-picker>
                    </el-form-item>
                    
                    <el-form-item style="width:25%">
                    <el-button type="primary" size="medium" @click="onSubmit('searchForm')" style="width:80px;">查询</el-button>
                    <!-- <el-button type="text" @click="clearForm()" style="width: 60px;color: #169BD5;">重置</el-button> -->
                     <el-button type="success" size="medium" v-if="basicsAuth.returnMaterialAdd" @click="createOrder()">新建</el-button>
            <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')" >导出</el-button>
            <!-- <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 10px" @click="refresh()"></i> -->
                </el-form-item>
                <!-- </div> -->
            </el-form>
        </el-col>
        <el-col>
            <el-card class="box-card" style="width: 100%;">
                <el-table
                    id="tableId"
                    :data="returnData"
                    border
                    @row-click="goToDetail"
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%">
                    <el-table-column
                        align="center"
                        prop="code"
                        label="编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createUserName"
                        label="创建人">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="sum"
                        label="数量">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="status"
                        label="状态">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createTime"
                        label="退料日期">
                    </el-table-column>
                </el-table>
            </el-card>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100,1000]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>
    </div>
</template>

<script>
    import PinyinMatch from 'pinyin-match';
    let moment = require("moment");
    import {
        returnMaterialType,
        engineerList,
        queryUserList,
        returnMaterialDataList,
        selectParameterInfoBusiness
    } from "../../api/api";
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'returnMaterManageList',
        components: {
        },
        data () {
            return {
                valueTime3:[],
                pickingTypeList:[   //退料类型
                    {
                        paraName:'普通退料',
                        paraCode:1
                    },
                    {
                        paraName:'残值退料',
                        paraCode:2
                    }
                ],
                statusList:[
                    {
                        paraName:'已确认',
                        paraValue:'YQR'
                    },
                    {
                        paraName:'暂存',
                        paraValue:'save'
                    }
                ],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                searchForm:{
                    code:'',
                    status:'',
                    returnType:'',
                    createUser:'',
                    createTimeFrom:'',
                    createTimeTo:'',
                },
                returnData: [],
                copy:[],
                reciverList:[],       //收料人
                returnList:[],        //退料类型
                basicsAuth:{
                    returnMaterialAdd:false
                }
            }
        },
        mounted(){
            this.basicsAuth.returnMaterialAdd = getPermission("/api/returnMaterial/returnMaterialAdd")
        },
        created(){
            this.getReciverList();
            this.getReturnList();
            this.returnMaterialList();
        },
        methods: {
            changeCreateUser(e){
                this.searchForm.createUser = e;
                this.$forceUpdate();
            },
            //领料人拼音模糊搜索
            PinyinMatch1(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy.forEach(i => {
                        let m = PinyinMatch.match(i.staffName,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.createUser = val;
                    this.reciverList = result;
                }else{
                    this.reciverList = this.copy;
                    this.searchForm.createUser = "";
                }
            },
            //获取创建人列表
            getReciverList(){
                queryUserList({startRow:1,pageSize:1000}).then(res => {
                    if (res.data.status==100) {
                        this.reciverList = res.data.results.list;
                        this.copy = Object.assign(this.reciverList); //保留数据源
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取退料类型列表
            getReturnList(){
                let params = {
                    paraType:'sales_return_type'
                }
                selectParameterInfoBusiness(params).then(res => {
                    if (res.data.status==100) {
                        this.returnList = res.data.results.list;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            clearForm(){
                this.searchForm = {}
                this.valueTime3 = []
                this.onSubmit('searchForm');
            },
            //获取退料管理列表
            returnMaterialList(){
                this.searchForm.startRow = this.pages.page;
                this.searchForm.pageSize = this.pages.pageSize;
                returnMaterialDataList(this.searchForm).then(res => {          
                    if (res.data.status==100) {            
                            this.returnData = res.data.results.list
                            this.returnData.forEach((item,index)=>{
                                item.createTime = this.filters.formatDate(item.createTime)
                            })
                            this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.returnMaterialList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.returnMaterialList()
            },
            //进入详情页面
            goToDetail(row) {
                if(row.status == '暂存'){
                    this.$router.push({
                        path:'/editReturnMater',
                        query:{
                          orderId:row.id
                        }
                    })
                }
            },
            //新建退料
            createOrder() {
                this.$router.push({
                    path:'/newReturnMater'
                })
            },
            refresh() {
                this.searchForm = {}
                this.returnMaterialList();
            },
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        if(this.valueTime3 == null){
                            this.searchForm.createTimeFrom = "";
                            this.searchForm.createTimeTo = "";
                        }else if(this.valueTime3.length == 0){
                            this.searchForm.createTimeFrom = "";
                            this.searchForm.createTimeTo = "";
                        }else{
                            this.searchForm.createTimeFrom = new Date(this.valueTime3[0])
                            this.searchForm.createTimeTo = new Date(this.valueTime3[1])
                        }
                        this.returnMaterialList()
                      
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    #returnMaterManageList{
        font-size: 14px;
        .el-form-item{
            margin-bottom:15px
        }
        .headerT{
            margin:0 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px; 
        }
    }
 .hewidth {
        width: 11% !important;
      }
</style>



// WEBPACK FOOTER //
// returnMaterManageList.vue?6b2ec479